import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faCalendarAlt,
  faMapMarkerAlt,
  faShoppingBag,
  faMoneyBillWave,
  faCreditCard,
  faStar,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./pending_order_notification.module.css";
import usePendingCart from "../../../hooks/usePendingCart";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import SpinningArrow from "../loaders/SpinningArrow";

const PendingOrderNotification = ({ isIcon = false, onClose }) => {
  const { data: pendingOrders } = usePendingCart();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const hasPendingOrders = pendingOrders && pendingOrders.length > 0;

  if (!hasPendingOrders) {
    return null;
  }

  const handleViewOrder = (reference) => {
    setShowModal(false);
    navigate(`/order/${reference}`);
  };

  // Composant pour l'icône animée
  if (isIcon) {
    return (
      <>
        <SpinningArrow
          badgeCount={pendingOrders.length}
          onClick={() => setShowModal(true)}
          size="small"
        />

        <PendingOrderModal
          show={showModal}
          onHide={() => setShowModal(false)}
          pendingOrders={pendingOrders}
          onViewOrder={handleViewOrder}
        />
      </>
    );
  }

  // Composant pour la sidebar
  return (
    <>
      <div
        className={styles.pendingOrderAlert}
        onClick={() => setShowModal(true)}
      >
        <SpinningArrow
          // badgeCount={pendingOrders.length}
          onClick={() => setShowModal(true)}
          size="small"
        />
        <div className={styles.pendingOrderInfo}>
          <h4>Commande en cours</h4>
          {/* <p>Référence: {pendingOrders[0].reference}</p>
          <p>Montant: {pendingOrders[0].total_with_delivery} FCFA</p> */}
        </div>
      </div>

      <PendingOrderModal
        show={showModal}
        onHide={() => setShowModal(false)}
        pendingOrders={pendingOrders}
        onViewOrder={handleViewOrder}
      />
    </>
  );
};

// Fonction pour formater la date en français
const formatDate = (dateString) => {
  const options = {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return new Date(dateString).toLocaleDateString("fr-FR", options);
};

// Composant Modal pour afficher les détails
const PendingOrderModal = ({ show, onHide, pendingOrders, onViewOrder }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName={styles.orderModal}
      contentClassName={styles.modalContent}
    >
      <Modal.Header className={styles.modalHeader}>
        <Modal.Title>
          <div className={styles.modalTitleContainer}>
            <SpinningArrow size="small" />
            <span className={styles.modalTitleText}>Commandes en cours</span>
          </div>
        </Modal.Title>
        <button className={styles.closeButton} onClick={onHide}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        {pendingOrders.map((order, index) => (
          <div key={index} className={styles.orderItem}>
            <div className={styles.orderHeader}>
              <div className={styles.supplierInfo}>
                <FontAwesomeIcon icon={faStore} className={styles.storeIcon} />
                <span className={styles.supplierName}>
                  {order.supplier_name ? order.supplier_name : "Epicerie en ligne"}
                </span>
              </div>
              <div className={styles.orderRef}>#{order.reference}</div>
            </div>

            <div className={styles.orderContent}>
              <div className={styles.orderInfoColumn}>
                <div className={styles.infoItem}>
                  <FontAwesomeIcon icon={faCalendarAlt} className={styles.infoIcon} />
                  <div className={styles.infoContent}>
                    <span className={styles.infoLabel}>Date :</span>
                    <span className={styles.infoValue}>{formatDate(order.date)}</span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.infoIcon} />
                  <div className={styles.infoContent}>
                    <span className={styles.infoLabel}>Adresse :</span>
                    <span className={styles.infoValue}>{order.address}</span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <FontAwesomeIcon icon={faShoppingBag} className={styles.infoIcon} />
                  <div className={styles.infoContent}>
                    <span className={styles.infoLabel}>Articles :</span>
                    <span className={styles.infoValue}>{order.items_count}</span>
                  </div>
                </div>
              </div>

              <div className={styles.orderInfoColumn}>
                <div className={styles.infoItem}>
                  <FontAwesomeIcon icon={faMoneyBillWave} className={styles.infoIcon} />
                  <div className={styles.infoContent}>
                    <span className={styles.infoLabel}>Montant :</span>
                    <span className={styles.infoValue}>{order.total_with_delivery} FCFA</span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <FontAwesomeIcon
                    icon={order.paiment_mode === "cash" ? faMoneyBillWave : faCreditCard}
                    className={styles.infoIcon}
                  />
                  <div className={styles.infoContent}>
                    <span className={styles.infoLabel}>Paiement :</span>
                    <span className={styles.infoValue}>
                      {order.paiment_mode === "cash" ? "Espèces" : order.paiment_mode}
                    </span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <FontAwesomeIcon icon={faStar} className={styles.infoIcon} />
                  <div className={styles.infoContent}>
                    <span className={styles.infoLabel}>Points gagnés :</span>
                    <span className={styles.infoValue}>{order.points_earned}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default PendingOrderNotification;
